<div class="sub-title-container">
  <span class="sub-title">{{model.subTitle$() | translate}}</span>
</div>
